angular
    .module('noc')
    .constant('TripDashboardStatus', {
        NO_STATUS : 'I18N_TRIP.SELECT_PARAMETERS',
        SEARCHING_TRIPS: 'I18N_TRIP.SEARCHING',
        SEARCHING_TRIP_DATA : 'I18N_TRIP.DATA_SEARCHING',
        NO_TRIPS_FOUND : 'I18N_TRIP.NO_TRAINS_FOUND',
        NO_TRIP_DATA_FOUND: 'I18N_TRIP.NO_TRIP_DATA_FOUND',
        TRIP_DATA_FOUND : 'I18N_TRIP.DATA_FOUND'
    });
